export default __webpack_public_path__ + "static/media/large.494aac42.jpg";